import type { DeepReadonly } from 'utility-types';

import { GatewayServiceClient } from '@playq/octopus-notifications';

import { tryToSendEphemeral, websocketTransport } from '../core';

const gatewayService = new GatewayServiceClient(websocketTransport);

export const gatewayEphemeral: DeepReadonly<{
  send: InstanceType<typeof GatewayServiceClient>['sendEphemeral'];
}> = {
  send: async (...args) =>
    tryToSendEphemeral(
      () => gatewayService.sendEphemeral(...args),
      () => Promise.resolve()
    ),
};
